import type { ABTestGroup } from "../../types/ABTestGroup";

export const getHexRemainder = (hexString: string): ABTestGroup => {
  // 最後の文字（最下位ビット）を取得
  const lastChar = hexString.charAt(hexString.length - 1).toLowerCase();

  // 最後の文字が偶数か奇数かをチェック
  const isOdd = ["1", "3", "5", "7", "9", "b", "d", "f"].includes(lastChar);

  // 奇数なら余りは1、偶数なら余りは0
  return isOdd ? "B_GROUP" : "A_GROUP";
};
